import { HTMLAttributes } from "react";

interface LoadingDotsProps extends HTMLAttributes<HTMLDivElement> {}

export const LoadingDots = (props: LoadingDotsProps) => {
    return (
        <div className="loading-dots" {...props}>
            <span>.</span>
            <span>.</span>
            <span>.</span>
        </div>
    );
};